import MarketTicker from "@/components/MarketTicker";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import PromoBanner from "@/components/PromoBanner";
import InnovationShowcase from "@/components/InnovationShowcase";
import AboutSection from "@/components/AboutSection";
import ServicesSection from "@/components/ServicesSection";
import InsightsSection from "@/components/InsightsSection";
import MarketDashboard from "@/components/MarketDashboard";
import TestimonialsSection from "@/components/TestimonialsSection";
import RiskDisclosure from "@/components/RiskDisclosure";
import BookingSection from "@/components/BookingSection";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import FloatingWidgets from "@/components/FloatingWidgets";

export default function LandingPage({ started, theme, onToggleTheme }) {
  return (
    <div data-testid="landing-page" className="relative bg-void">
      <div className="noise-overlay" />
      <MarketTicker />
      <Navbar theme={theme} onToggleTheme={onToggleTheme} />
      <main>
        <HeroSection started={started} />
        <PromoBanner />
        <InnovationShowcase />
        <AboutSection />
        <ServicesSection />
        <InsightsSection />
        <MarketDashboard />
        <TestimonialsSection />
        <RiskDisclosure />
        <BookingSection />
        <ContactSection />
      </main>
      <Footer />
      <FloatingWidgets />
    </div>
  );
}
